// @flow
import { makeStyles } from '@material-ui/core/styles';
import i18n from 'i18next';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter, Switch } from 'react-router-dom';
import routes from './routes';
import './App.css';
import AppRoute from './component/AppRoute';
import { AuthProvider } from './context/auth';
import { lang, resources } from './i18n/es';
import Contract from './screen/Contract';
import Validation from './screen/Validation';
import Home from './screen/Home';
import Process from './screen/Process';
import Profile from './screen/Profile';
import SignIn from './screen/SignIn';
import SignUp from './screen/SignUp';
import RecoverPassword from './screen/RecoverPassword';
import ChangePassword from './screen/ChangePassword';
import { mergeObjects } from './util/common';
import HelpLinks from './screen/HelpLinks';
import Selfie from './screen/Selfie';
import PaymentBack from './screen/PaymentBack';
import ValidationBack from './screen/ValidationBack';

const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: theme.palette.success[ '500' ],
  },
  error: {
    backgroundColor: theme.palette.error[ '600' ],
  },
}));

type Props = {
  provider: string,
};

const App = (props: Props) => {
  const classes = useStyles();
  const { provider } = props;
  return (
    <AuthProvider>
      <SnackbarProvider maxSnack={3} classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
      }}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Switch>
            <AppRoute exact
                      path={routes.signUp}
                      custom={{
                        provider,
                      }}
                      Component={SignUp}
                      ispublic/>
            <AppRoute exact
                      path={routes.signIn}
                      Component={SignIn}
                      ispublic/>
            <AppRoute exact
                      path={routes.recoverPassword}
                      Component={RecoverPassword}
                      ispublic/>
            <AppRoute exact
                      path={routes.changePassword}
                      Component={ChangePassword}
                      ispublic/>
            <AppRoute exact
                      path={routes.home}
                      custom={{
                        provider,
                      }}
                      Component={Home}/>
            <AppRoute exact
                      path={routes.profile}
                      Component={Profile}/>
            <AppRoute path={`${routes.process}/:code`}
                      Component={Process}/>
            <AppRoute path={`${routes.contract}/:code/retail/:token`}
                      custom={{
                        isRetailClient: true,
                      }}
                      Component={Contract}
                      ispublic
                      keeponpublic/>
            <AppRoute path={`${routes.contract}/:code/:token`}
                      custom={{
                        isRetailClient: false,
                      }}
                      Component={Contract}
                      ispublic
                      keeponpublic/>
            <AppRoute path={`${routes.contractValidation}/:code/:token`}
                      custom={{
                        isRetailClient: false,
                      }}
                      Component={Validation}
                      ispublic
                      keeponpublic/>
            <AppRoute path={`${routes.selfie}/:code/retail/:token`}
                      custom={{
                        isRetailClient: true,
                      }}
                      Component={Selfie}
                      ispublic
                      keeponpublic/>
            <AppRoute path={`${routes.selfie}/:code/:token`}
                      custom={{
                        isRetailClient: false,
                      }}
                      Component={Selfie}
                      ispublic
                      keeponpublic/>
            <AppRoute exact
                      path={routes.links}
                      custom={{
                        provider,
                      }}
                      Component={HelpLinks}/>
            <AppRoute path={`${routes.payment}/:code`}
                      Component={PaymentBack}
                      ispublic
                      keeponpublic/>
            <AppRoute path={`${routes.validation}/:code`}
                      Component={ValidationBack}
                      ispublic
                      keeponpublic/>
          </Switch>
        </BrowserRouter>
      </SnackbarProvider>
    </AuthProvider>
  );
};

App.initI18n = async (customResources: any) => {
  await i18n
    .use(initReactI18next)
    .init({
      resources: mergeObjects(resources, customResources),
      lng: lang,
      fallbackLng: lang,
      interpolation: {
        escapeValue: false,
      },
    });
};

export default App;
